import React from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { injectModels } from "../../../redux/injectModels";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { SubscriptionService } from "../../../services";
import Editor from "react-simple-wysiwyg";

import {
  handleConsoleError,
} from "../../../utils/common-methods";

function Subscription(props) {
  const [showModal, setShow] = useState(false);
  const [error, setError] = useState("");
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [commission, setCommission] = useState(0);

  const [isactive, setIsActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  //const [icon, setIcon] = useState(null);
  // const [preview, setPreview] = useState(null);
  // const maxSize = 1024 * 1024; // 1MB
  // const desiredWidth = 100;
  // const desiredHeight = 120;

  useEffect(() => {
    getData();
  }, []);

  const handleClose = () => {
    setShow(false);
    setError("");
    //setPreview(null);
  };
  const handleShow = () => setShow(true);

  // const handleAdd = async (e) => {
  //   setId("");
  //   setName("");
  //   setDescription("");
  //   setIsActive(false);
  //   handleShow();
  //   setError("");
  // };

  const getData = async () => {
    props.application.setLoading(true);

    try {
      const res = await SubscriptionService.getSubscriptionList();
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
        props.application.setLoading(false);
      } else {
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
    }
  };

  const handleName = (e) => {
    e.preventDefault();
    const val = e.target.value;
    if (val?.trim() === "") {
      setError("Name is required");
    } else {
      setError("");
    }
    setName(val);
  };

  const handleDescription = (e) => {
    //e.preventDefault();
    const val = e.target.value;

    if (val?.trim() === "<br>") {
      setError("Description is required");
    } else {
      setError("");
    }
    setDescription(val);
  };

  const handleCommission = (e) => {
    e.preventDefault();
    const val = e.target.value;
    if (val?.trim() === "") {
      setError("Commission is required");
    } else if (isNaN(val?.trim())) {
      setError("Please enter numeric value for commission");
    } else {
      setError("");
    }
    setCommission(val);
  };

  const handleIsActive = (event) => {
    setIsActive(event.target.checked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = true;

    if (name?.trim() === "") {
      setError("Name is required");
      valid = false;
      return;
    } else {
      setError("");
    }
    if (description?.trim() === "<br>") {
      setError("Description is required");
      valid = false;
      return;
    } else {
      setError("");
    }

    if (!commission || isNaN(commission) || commission === 0) {
      setError("Commission is required");
      valid = false;
      return;
    } else {
      setError("");
    }

    // if (!preview || preview.trim() === "") {
    //   setError("Image is required");
    //   valid = false;
    //   return;
    // } else {
    //   setError("");
    // }

    if (!valid) {
      setError("Please fill all fields");
      return;
    } else {
      setError("  ");
      try {
        props.application.setLoading(true);

        const data = {
          SubscriptionPlanName: name?.trim(),
          description: description?.trim(),
          commission: commission,
          isactive: isactive,
          id: id,
        };
        const res = await SubscriptionService.updateSubscription(data);
        if (res?.isSuccess) {
          props.application.setLoading(false);
          toast.success(res?.message);
        } else {
          toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
          props.application.setLoading(false);
        }
        // }
        handleClose();
        setId("");
        getData();
      } catch (err) {
        props.application.setLoading(false);
        const message = handleConsoleError(err);
        toast.error(err?.message || message);
        setId("");
      }
    }
  };

  const handleEdit = async (id) => {
    try {
      props.application.setLoading(true);
      const res = await SubscriptionService.getSubscriptionById(id);

      if (res?.isSuccess) {
        setName(res?.data?.subscriptionPlanName);
        setDescription(res?.data?.description);
        setCommission(res?.data?.commission);
        setIsActive(res?.data?.isActive);
        setId(id);
        handleShow();
        props.application.setLoading(false);
      } else {
        //toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
        props.application.setLoading(false);
      }
    } catch (error) {
       const message = handleConsoleError(error);
      props.application.setLoading(false);
      toast.error(error?.message||message);
    }
  };

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);

    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }

    const pageCount = Math.ceil(filteredData.length / rowsPerPage);

    if (filteredData.length === 0) {
      setShowNextButton(false);
    } else if (selected === pageCount - 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     if (file.size > maxSize) {
  //       toast.error("File size exceeds the maximum limit of 1MB.");
  //       return;
  //     }
  //     if (!file.type.startsWith("image/")) {
  //       toast.error("Please upload a valid image file.");
  //       return;
  //     }
  //     const img = new Image();
  //     img.onload = () => {
  //       if (img.width !== desiredWidth || img.height !== desiredHeight) {
  //         setError(
  //           `Image must be ${desiredWidth}px wide and ${desiredHeight}px high.`
  //         );
  //         return;
  //       } else {
  //         setIcon(file);
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //           setPreview(reader.result);
  //         };
  //         reader.readAsDataURL(file);
  //       }
  //     };
  //     img.src = URL.createObjectURL(file);
  //   }
  // };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            {/* <li className="breadcrumb-item">Content Management</li>*/}
            <li className="breadcrumb-item active">Subscription</li>
          </ol>
        </nav>
      </div>

      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        className="custom-contract-modal"
      >
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>{id === "" ? "Add" : "Update"} Subscription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="searchformfld">
              <label>
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Name"
                value={name}
                maxLength="100"
                onChange={handleName}
                required
              />
              <label>
                Description <span className="text-danger">*</span>
              </label>
              <Editor value={description} onChange={handleDescription} />

              <label className="mt-3">
                Commission (%) <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control mb-3"
                placeholder="Commission"
                value={commission}
                maxLength="5"
                onChange={handleCommission}
                required
              />
              {/* <label className="mt-3">
                Image (Preferred Dimensions: 100px*120px){" "}
                <span className="text-danger">*</span>
              </label>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  required
                />
              </div>
              {preview && (
                <div>
                  <img
                    src={preview}
                    alt="Icon Preview"
                    style={{ width: "100px", height: "100px" }}
                  />
                </div>
              )} */}

              <div className="custom-check" style={{ marginTop: "10px" }}>
                <label>Status </label>
                <input
                  type="checkbox"
                  checked={isactive} // Controlled by state
                  onChange={handleIsActive} // Handle change event
                />
              </div>
            </div>
            {error && <span className="text-danger">{error}</span>}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            type="submit"
            variant="primary custom-button-colour"
            onClick={handleSubmit}
          >
            {id === "" ? "Save" : "Update"}
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="table-responsive">
        <div>
          <h2>Subscription</h2>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Description</th>
              <th>Commission(%)</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{calculateSNo(idx)}</td>
                      <td>{item?.subscriptionPlanName}</td>
                      <td>
                        <p
                          dangerouslySetInnerHTML={{ __html: item?.description }}
                        />
                      </td>

                      <td>{item?.commission}</td>
                      <td className="delete-create">
                        {item?.isActive === true ? (
                          <i className="ri-check-fill"></i>
                        ) : (
                          <i className="ri-close-circle-line"></i>
                        )}
                      </td>
                      <td>
                        <div className="delete-create">
                          <Link
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(item?.id);
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="ri-pencil-line"></i>
                          </Link>

                          {/*isDataLength === false ?  "":  */}
                          {/* <Link
                            onClick={(e) => {
                              e.preventDefault();
                              //handleDelete(item._id);
                            }}
                          >
                            <i className="ri-delete-bin-line"></i>
                          </Link> */}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className="table-footer">
        <strong>Total Count: {filteredData.length}</strong>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
}

export default injectModels(["admin", "application"])(Subscription);
